import { API_BASE } from "../config/appConfig"
import { apiFetch } from "../utils/apiFetch"

function buildParams({ clinicId, dateFrom, dateTo } = {}) {
  const params = new URLSearchParams()

  if (clinicId && clinicId !== "ALL") {
    params.append("clinicId", clinicId)
  }

  if (dateFrom) params.append("dateFrom", dateFrom)
  if (dateTo) params.append("dateTo", dateTo)

  return params.toString()
}

async function requestJson(path, params = {}, options = {}) {
  const query = buildParams(params)
  const url = `${API_BASE}${path}${query ? `?${query}` : ""}`

  const response = await apiFetch(url, options)
  const data = await response.json().catch(() => null)

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      `Error al consultar ${path}`

    throw new Error(message)
  }

  return data
}

export async function getFinancialExecutiveBundle(params) {
  return requestJson("/finance/executive-bundle", params)
}